<template>
  <div class='animated fadeIn'>
    <b-row>
      <b-col md='6'>
        <b-card>
          <div slot='header'>
            <strong><i class="fa fa-align-justify"></i> Traitement</strong>
          </div>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelle"><strong>Libellé : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="libelle" v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.libelle }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelle_court"><strong>Libellé court : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="libelle_court" v-model="libelle_court" :class="{hasError: errors.libelle_court !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.libelle_court }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelle_technique"><strong>Libellé technique : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="libelle_technique" v-model="libelle_technique" :class="{hasError: errors.libelle_technique !== ''}" disabled></b-form-input>
                <span class='field-error'>{{ errors.libelle_technique }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="categorie"><strong>Catégorie : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-select v-model="categorie" :options="categorieOptions" :class="{hasError: errors.categorie !== ''}">
                <template v-slot:first>
                  <b-form-select-option :value="''" disabled>-- Choisir une categorie --</b-form-select-option>
                </template>
              </b-form-select>
              <span class="field-error inline mr-1 float-right">{{ errors.categorie }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="ordre"><strong>Ordre : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="number" id="ordre" min="0" v-model="ordre"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="type"><strong>Type : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-select v-model="typeSelected" :options="typeOptions" :class="{hasError: errors.type !== ''}">
                <template v-slot:first>
                  <b-form-select-option :value="''" disabled>-- Choisir une type --</b-form-select-option>
                </template>
              </b-form-select>
              <span class="field-error inline mr-1 float-right">{{ errors.type }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1" v-if="displayStatus">
            <b-col sm="3">
              <label for="status"><strong>Status retour : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-select v-model="statusSelected" :options="statusOptions" :class="{hasError: errors.status !== ''}">
                <template v-slot:first>
                  <b-form-select-option :value="''" disabled>-- Choisir une status --</b-form-select-option>
                </template>
              </b-form-select>
              <span class="field-error inline mr-1 float-right">{{ errors.status }}</span>
            </b-col>
          </b-row>
          <hr>
          <b-row class="mb-1">
            <b-col sm="12">
              <h6 class="mb-3"><i>Couleur pour le tableau de résultat</i></h6>
              <b-row class="mb-3 mt-2">
                <b-col sm="3">
                  <label><strong>Prévisualisation : </strong></label>
                </b-col>
                <b-col sm="9">
                  <div id="colorPreview">Traitement <strong>Traitement</strong></div>
                </b-col>
              </b-row>
              <b-row class="mb-1 mt-2">
                <b-col sm="6">
                  <b-row>
                    <b-col sm="8">
                      <strong>Couleur de la police :</strong>
                    </b-col>
                    <b-col sm="4">
                      <chrome-picker id="chromePickerFont" v-model="colorsFont" @input="updateValue('font')" v-show="showColorPickerFont"/>
                      <img @click="colorPicker('font')" class="colorPicker" id="colorPickerFont" src="@/assets/images/color_picker_icon_30.png">
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="6">
                  <b-row>
                    <b-col sm="8">
                      <strong>Couleur de l'arrière plan :</strong>
                    </b-col>
                    <b-col sm="4">
                      <chrome-picker id="chromePickerBg" v-model="colorsBg" @input="updateValue('bg')" v-show="showColorPickerBg"/>
                      <img @click="colorPicker('bg')" class="colorPicker" id="colorPickerBg" src="@/assets/images/color_picker_icon_30.png">
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <div slot="footer">
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"></i> Liste des traitements
            </b-button>
            <b-button type="button" @click="edit" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"></i> Enregistrer
            </b-button>
          </div>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card no-body>
          <b-card-header>
            <i class="fa fa-list mr-2"></i>
            <strong>Attacher un statut </strong>
          </b-card-header>
          <b-card-body>
            <div class="col-md-12">
              <b-card no-body>
                <b-card-body>
                  <b-form-group>
                    <label for="typeStatus"><strong>Type : </strong></label>
                    <b-form-select
                      id="typeStatus"
                      v-model="selectedType"
                      :options="allTypes">
                      <template v-slot:first>
                        <b-form-select-option :value="null">-- Tous --</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group>
                    <label for="status"><strong>Statuts : </strong></label>
                    <multiselect selectLabel='Appuyer pour sélectionner'
                                 selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer pour désélectionner'
                                 :close-on-select="false"
                                 v-model="status"
                                 id="status"
                                 tag-placeholder="Choisissez un status"
                                 placeholder="Par défaut Aucun"
                                 label="name"
                                 track-by="code"
                                 :options="allStatus"
                                 :multiple="true"
                                 :taggable="true">
                    </multiselect>
                  </b-form-group>
                  <b-button
                    type="button"
                    @click="attach"
                    class="pull-right mt-4"
                    size="md"
                    variant="primary">
                    Attacher
                  </b-button>
                </b-card-body>
              </b-card>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import Multiselect from 'vue-multiselect'
  import itemList from "@/components/SortListItem";
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {isEmpty} from "@/utils/fileHelper";
  import {Chrome} from 'vue-color';

  let colorsFont = {
    hex: null,
    hsl: {h: null, s: null, l: null, a: null},
    hsv: {h: null, s: null, v: null, a: null},
    rgba: {r: null, g: null, b: null, a: null},
    a: null
  };
  let colorsBg = {
    hex: null,
    hsl: {h: null, s: null, l: null, a: null},
    hsv: {h: null, s: null, v: null, a: null},
    rgba: {r: null, g: null, b: null, a: null},
    a: null
  };

  export default {
    name: "Edit",
    components: {
      Multiselect,
      itemList,
      'chrome-picker': Chrome
    },
    data() {
      return {
        displayStatus: false,
        id: '',
        allStatus: [],
        statusList: [],
        status: [],
        selectedStatus: [],
        attachedStatus: [],
        libelle: '',
        libelle_court: '',
        libelle_technique: '',
        categorie: '',
        ordre: '',
        statusOptions: [],
        statusSelected: '',
        typeOptions: [
          {value: "Principal", text: "Principal"},
          {value: "Secondaire", text: "Secondaire"},
        ],
        categorieOptions: [
          {value: "Production", text: "Production"},
          {value: "Controle", text: "Controle"},
        ],
        typeSelected: '',
        colorsFont,
        colorsBg,
        showColorPickerFont: false,
        showColorPickerBg: false,
        errors: {
          libelle: '',
          libelle_court: '',
          libelle_technique: '',
          categorie: '',
          type: '',
          status: '',
        },
        allTypes: [],
        selectedType: null,
        allDossierStatuts: [],
      }
    },
    watch: {
      status: function () {
        if (this.status) {
          this.selectedStatus = this.status.map(item => item.code)
        } else {
          this.selectedStatus = []
        }
      },
      typeSelected: function() {
        this.displayStatus = this.typeSelected === 'Secondaire';
      },
      selectedType: async function() {
        await this.setStatusList();
      },
    },
    async mounted() {
      await this.getTraitement();
      this.getTypes();
      this.getStatusATraiter();
      this.id = this.$route.params.id;
      await this.getStatus();

    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken();
      this.$axios.defaults.headers.common['Accept'] = 'application/json';
      this.$axios.defaults.headers.common['Provider'] = getProvider();
    },
    methods: {
      updateValue(type) {
        if (type === 'font') {
          let preview = document.getElementById('colorPreview');
          preview.style.color = this.colorsFont.hex;
        } else if (type === 'bg') {
          let preview = document.getElementById('colorPreview');
          preview.style.backgroundColor = this.colorsBg.hex;
        }
      },
      colorPicker(type) {
        if (type === 'font') {
          this.showColorPickerFont = !this.showColorPickerFont;
          this.showColorPickerBg = false;
          if (this.showColorPickerFont) {
            let colorWheelFont = document.getElementById('colorPickerFont')
            let posWheelFont = colorWheelFont.getBoundingClientRect()
            let colorPickerFont = document.getElementById('chromePickerFont')
            let posColorPickerFont = colorPickerFont.getBoundingClientRect()
            colorPickerFont.style.left = (posWheelFont.x - 462) + 'px'
          }
        } else if (type === 'bg') {
          this.showColorPickerBg = !this.showColorPickerBg;
          this.showColorPickerFont = false;
          if (this.showColorPickerBg) {
            let colorWheelBg = document.getElementById('colorPickerBg')
            let posWheelBg = colorWheelBg.getBoundingClientRect()
            let colorPickerBg = document.getElementById('chromePickerBg')
            let posColorPickerBg = colorPickerBg.getBoundingClientRect()
            colorPickerBg.style.left = '53px'
          }
        }
        
      },
      async getTraitement() {
        this.$store.commit('IS_LOADING', true)
        let self = this;
        await this.$axios
          .get("/administration/traitements/" + this.$route.params.id)
          .then(response => {
            this.libelle = response.data.traitement.libelle;
            this.libelle_court = response.data.traitement.libelle_court;
            this.libelle_technique = response.data.traitement.libelle_technique;
            this.categorie = response.data.traitement.categorie;
            this.ordre = response.data.traitement.ordre;
            this.typeSelected = response.data.traitement.type;
            this.statusSelected = response.data.traitement.status_retour_id;
            this.attachedStatus = response.data.traitement.status;
            this.colorsFont.hex = response.data.traitement.font_color;
            this.colorsBg.hex = response.data.traitement.bg_color;
            this.updateValue('font');
            this.updateValue('bg');
            this.findStatus();
            this.$store.commit('IS_LOADING', false);
            // console.log('response.data',response.data)
            // console.log('this.colorsFont',this.colorsFont)
          })
          .catch((error) => {
            self.$store.commit('IS_LOADING', false)
            if (error.response && error.response.status === 404 && self != undefined) {
              self.$router.push({path: '/administration/traitements'})
              self.$swal({
                position: 'top',
                type: 'warning',
                title: 'Attention !!',
                text: 'le traitement avec l\'id ' + id + ' n\'existe pas',
                showConfirmButton: false,
                timer: 5000
              });
            }
          });
      },
      edit() {
        if (this.validateData()) {
          this.$store.commit('IS_LOADING', true);
          let self = this;
          let dataPost = {};
          dataPost.libelle = this.libelle;
          dataPost.libelle_court = this.libelle_court;
          dataPost.libelle_technique = this.libelle_technique;
          dataPost.categorie = this.categorie;
          dataPost.ordre = this.ordre;
          dataPost.type = this.typeSelected;
          dataPost.status_retour_id = this.statusSelected;
          dataPost.font_color = this.colorsFont.hex;
          dataPost.bg_color = this.colorsBg.hex;

          this.$axios
            .put("/administration/traitements/" + this.id, dataPost)
            .then(() => {
              this.$store.commit('IS_LOADING', false);
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Modification avec succès',
                text: 'Le traitement ' + dataPost.libelle + ' a bien été modifié',
                showConfirmButton: false,
                timer: 5000
              });
              this.clearFields();
              this.returnBack();
            })
            .catch(() => {
              self.$store.commit('IS_LOADING', false);
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Un problème est survenu, merci de contacter l\'administration',
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      returnBack() {
        this.$router.push({path: '/administration/traitements'})
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.libelle.trim() === '') {
          this.errors.libelle = 'Le libelle est obligatoire';
          valid = false;
        }
        if (this.libelle_court.trim() === '') {
          this.errors.libelle_court = 'Le libellé court est obligatoire';
          valid = false;
        }
        if (this.libelle_technique.trim() === '') {
          this.errors.libelle_technique = 'Le libellé technique est obligatoire';
          valid = false;
        }
        if (this.categorie.trim() === '') {
          this.errors.categorie = 'La catégorie est obligatoire';
          valid = false;
        }
        if (this.typeSelected.trim() === '') {
          this.errors.type = 'Le type est obligatoire';
          valid = false;
        }
        if (this.typeSelected.trim() === 'Secondaire' && isEmpty(this.statusSelected)) {
          this.errors.status = 'Le statut de retour est obligatoire';
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.libelle = '';
        this.errors.libelle_court = '';
        this.errors.libelle_technique = '';
        this.errors.categorie = '';
        this.errors.type = '';
        this.errors.status = '';
      },
      clearFields() {
        this.libelle = '';
        this.libelle_court = '';
        this.libelle_technique = '';
        this.categorie = '';
        this.typeSelected = '';
        this.statusSelected = '';
      },
      async getStatus() {
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/administration/allDossierStatuts")
          .then(async (response) => {
            this.$store.commit("IS_LOADING", false);
            this.allDossierStatuts = response.data.status;
            await this.setStatusList();
          })
          .catch((error) => {
            this.handleError(this, error);
          });
      },
      populateStatus() {
        this.status = [];
        const selectedStatus = this.attachedStatus.map(el => el.id);
        for (let statusId of selectedStatus) {
          let name = "";
          for (let status of this.allStatus) {
            if (status.code === parseInt(statusId)) {
              name = status.name;
              this.status.push({code: statusId, name: name});
            }
          }
        }
      },
      attach() {
        if (this.validateFields()) {
          this.$store.commit("IS_LOADING", true);
          const dataPost = {
            status: this.selectedStatus,
          };
          this.$axios
            .post("/administration/traitements/attachStatus/" + this.id, dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Félicitations !",
                text: "Traitement attaché avec succès",
                showConfirmButton: false,
                timer: 3500
              });
            })
            .catch((error) => {
              this.handleError(this, error);
            });
        }
      },
      handleError(self, error) {
        self.$store.commit("IS_LOADING", false);
        self.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
          showConfirmButton: false,
          timer: 5000
        });
      },
      validateFields() {
        let isValid = true
        if (this.selectedTraitement === '') {
          this.errors.traitement = 'Veuillez choisir un traitement'
          isValid = false
        }
        return isValid;
      },
      findStatus() {
        this.status = [];
        if (this.attachedStatus.length > 0) {
          for (let j = 0; j < this.attachedStatus.length; j++) {
            this.selectedStatus.push(this.attachedStatus[j].id)
          }
          this.populateStatus();
        } else {
          this.status = []
        }
      },
      getStatusATraiter() {
        let data = {
          libelle_categorie: 'status_dossier',
          libelle_status: 'a_traiter'
        };
        this.$axios
          .post("/administration/status/statutsByLibelle", data)
          .then(response => {
            const status = response.data.status ? response.data.status.sous_statuts : [];
            for (let i = 0; i < status.length; i++) {
              this.statusOptions.push({
                text: status[i].libelle_bo,
                value: status[i].id
              });
            }
          })
          .catch((error) => {
            console.log(error)
          });
      },
      getTypes() {
        this.$axios
          .get("/administration/statuts/typesStatus")
          .then(response => {
            for(let type of response.data.data){
              this.allTypes.push({value: type.id, text: type.libelle});
            }
          })
          .catch(function() {
            this.handleError(this, error);
          });
      },
      async setStatusList() {
        this.allStatus = [];
        this.status = [];
        this.statusList = [];
        let dossierStatuts = this.allDossierStatuts;
        let parent = [];
        let transition = [];
        if(!isEmpty(this.selectedType)) {
          dossierStatuts = this.allDossierStatuts.filter(val => val.types.some(({id}) => id === parseInt(this.selectedType, 10)));
        }
        if(dossierStatuts.length > 0) {
          transition = _.groupBy(dossierStatuts, 'parent_id');
          for (let index in transition) {
            if (index !== 'null') {
              for (let index2 in transition[index]) {
                if (this.statusList[index]) {
                  this.statusList[index].push(transition[index][index2])
                } else {
                  this.statusList[index] = []
                  this.statusList[index].push(transition[index][index2])
                }
              }
            }
          }
          for (let index in transition['null']) {
            parent[transition['null'][index].id] = transition['null'][index]
            if (this.statusList[transition['null'][index].id]) {
              this.statusList[transition['null'][index].id].unshift(transition['null'][index])
            } else {
              if (this.statusList[0]) {
                this.statusList[0].push(transition['null'][index])
              } else {
                this.statusList[0] = []
                this.statusList[0].push(transition['null'][index])
              }
            }
          }
          for (let groupStatus of this.statusList) {
            if (groupStatus) {
              for (let status of groupStatus) {
                if (status.parent_id) {
                  this.allStatus.push({
                    code: status.id,
                    name: !isEmpty(parent[status.parent_id]) ?
                      status.libelle_bo + '  (' + parent[status.parent_id].libelle_bo + ')' : isEmpty(status.parent) ? status.libelle_bo : status.libelle_bo + '  (' + status.parent.libelle_bo + ')'
                  })
                } else {
                  this.allStatus.push({code: status.id, name: status.libelle_bo})
                }
              }
            }
          }
          this.populateStatus();
        } else if(dossierStatuts.length === 0) {
          this.populateStatus();
        }
      }
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  #colorPreview {
    width: 85%;
    height: 30px;
    border: 1px solid #EEEEEE;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
  }

  .colorPicker {
    margin-left: 5px;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
  }

  .vc-chrome {
    position: absolute;
    z-index: 1001;
  }
</style>
